// extracted by mini-css-extract-plugin
export default {"table":"FilesComponent_table__ecepF","inline":"FilesComponent_inline__L83tn"};